import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateVoiceCallListService=async(data)=>{
    try {
        const result = await publicPost(`api/admin/voicecalllist/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateVoiceCallListService=async(data,id)=>{
    try {
        const result = await put(`api/admin/voicecalllist/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateReTargetFinalCheckCustomerService=async(data,id)=>{
    try {
        const result = await put(`api/admin/voicecalllist/update_final_check/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetVoiceCallListService=async(page)=>{
    try {
        const result = await get(`api/admin/voicecalllist/get?page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetVoiceCallListDetailService=async(id)=>{
    try {
        const result = await get(`api/admin/voicecalllist/get_detail/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteVoiceCallListService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/voicecalllist/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetVoiceAllCallListAnsweredService=async(page,from_date,to_date)=>{
    try {
        const result = await get(`api/admin/voicecalllist/get_all_voice_call_list_answered?page=${page}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const UpdateVoiceAllCallListAnsweredService=async(id)=>{
    try {
        const result = await put(`api/admin/voicecalllist/update_voice_call_list/${id}`, {});
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateVoiceAllCallListAnsweredMassService=async()=>{
    try {
        const result = await put(`api/admin/voicecalllist/update_all_voice_call_list`,{});
        return result;
    } catch (err) {
        return err.response;
    }
}